<div class="container-fluid row_banner pb-5">
  <app-header></app-header>
  <div class="container">
    <div
      class="row text-center justify-content-center"
      style="align-content: center"
      id="paraph-main"
    >
      <div class="col-lg-9 col-md-9 mb-4" id="footergrammartext">
        <h1 class="w-100 fnt-w600-40" style="margin-top: 40px">
          Paraphrasing Tool
        </h1>
        <span
          class="w-100 d-inline-block main_text"
          style="margin-top: 0px !important"
          >Paraphrase sentences, paragraphs, blog posts, essays, and articles
          instantly with our free tool.</span
        >
      </div>
    </div>
    <div class="custom-card">
      <p
        class="text-left success-msg"
        *ngIf="got_recpatcha"
        [ngStyle]="{
          color: color,
          'background-color': '#f8d7da',
          padding: '2px'
        }"
      >
        <i class="fa fa-times-circle matr ml-1" aria-hidden="true"></i>
        {{ recaptcha_message }}
      </p>
      <div class="row">
        <div class="col-lg-1 col-md-2 col-12 icon-bar mt45">
          <div class="icon-bar">
            <div
              class="icon-bar-img"
              id="uploadFileS"
              value="Browse"
              onclick="document.getElementById('upload').click();"
            >
              <app-icons-free-tools [name]="'pcIcon'" />
              <input
                id="upload"
                data-name="upload-element"
                #fileInput
                accept=".txt,.doc,.docx,.pdf,.odt,.rtf,.tex"
                type="file"
                (change)="uploadFileSaveRedirect($event)"
              />
            </div>
            <div class="icon-bar-img" (click)="openDropboxChooser()">
              <app-icons-free-tools [name]="'dropboxIcon'" />
            </div>
         
            <div class="icon-bar-img" (click)="onGDriveClick()">
              <app-icons-free-tools [name]="'googleIcon'" />
            </div>
          </div>
        </div>
        <div class="col-lg-11 col-md-10 col-12 top-bar">
          
          <div class="row">
            <div
              class="col-lg-6 col-md-12 col-sm-12"
              style="overflow-y: auto; overflow-x: hidden"
            >
              <div
                class="upload-section"
                id="editor"
                #editor
                ngDefaultControl
                contenteditable="true"
                style="overflow-y: auto; overflow-x: hidden"
                (click)="onclickeditor($event)"
                [(ngModel)]="documentText"
                (keyup)="getContent($event, text)"
                spellcheck="false"
                data-gramm="false"
              ></div>

              <div *ngIf="showParagraph" class="editSectionDiv">
                <div *ngFor="let content of contentArray">
                  <app-icons-free-tools [name]="'checktextIcon'" />
                  <h3 class="editor-heading">{{ content.header }}</h3>
                  <p class="paragraph">{{ content.paragraph }}</p>
                  <div class="upload-buttons">
                    <button
                      [ngClass]="{
                        paste: button.text === 'Sample Text',
                        click: button.text === 'Paste Text',
                        'default-class': true
                      }"
                      *ngFor="let button of content.buttons"
                      class="textButtons"
                      (click)="executeAction(button.action)"
                    >
                      <app-icons-free-tools [name]="button.icon" />{{
                        button.text
                      }}
                    </button>
                  </div>
                </div>
              </div>
              <span *ngIf="char_count !== 0">
                <app-icons-free-tools
                  [name]="'deleteIcon'"
                  (click)="deleteText()"
                  class="icon-del"
                />
              </span>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12">
              <div
                class="result-section"
                id="Paraphraseresult"
                contenteditable="false"
                spellcheck="false"
                data-gramm="false"
              >
                <img
                  src="../../assets/images/paraphrasing tool/paraphase/result-section.png"
                  class="result-section-img"
                  style="
                    position: relative;
                    top: 40%;
                    left: 49%;
                    text-align: center;
                    transform: translate(-50%, -50%);
                    display: block;
                  "
                />
              </div>
            </div>
          </div>
          <div class="progress-loader-div">
            <div class="progress-loader" *ngIf="loaderAlert"></div>
          </div>
          <div class="edit-buttons">
            <div class="word-count">
              <p class="word-limit" style="margin: 0px">
                Words: {{ char_count === 0 ? 0 : word_count }}
              </p>
              <!-- <p class="word-limit"  *ngIf="!isUserLoggedin || isUserLoggedin">
                Words {{ char_count === 0 ? 0 : word_count }} /1000
              </p>
              <p class="word-limit"  *ngIf=" subscribed_user">
                Words {{ char_count === 0 ? 0 : word_count }} /10,000
              </p> -->
              <p style="margin: 0px">Total Characters: {{ char_count }}</p>
            </div>

            <!--  -->
            <div
              style="position: relative"
              class="grid items-center switch-language-dropdown-container"
            >
              <button
                (click)="toggleReportMenu($event)"
                class="switch-language-dropdown flex items-center gap-default justify-between text-14"
              >
                <span class="flex gap-default items-center">
                  <app-icons-free-tools
                    *ngIf="!iconRequireReattachment"
                    [name]="languages[selectedLanguage].icon"
                  ></app-icons-free-tools>
                  <span style="
                    text-wrap: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    width: 90px;
                    text-align: left !important;
                  ">{{ languages[selectedLanguage].name }}</span>
                </span>
                <app-icons name="chevronDown"></app-icons>
              </button>

              <ul
                style="display: none"
                class="language-menu p-0"
                (click)="switchLanguage($event)"
              >
                <li
                  [attr.data-language]="language"
                  *ngFor="let language of Object.keys(languages)"
                >
                  <app-icons-free-tools
                    [name]="languages[language].icon"
                  ></app-icons-free-tools>
                  {{ languages[language].name }}
                </li>
              </ul>
            </div>
            <!--  -->

            <div *ngIf="captchaVisible" class="captcha-modal-overlay">
              <div class="captcha-modal">
                <div
                  id="recaptcha-container"
                  class="recaptcha-container"
                  data-size="compact"
                  data-theme="light"
                ></div>
              </div>
            </div>
            <div class="right-buttons">
              <button
                id="adv-tech"
                class="download-img tooltipss butn"
                aria-label="Try Again"
                (click)="handleButtonClick()"
                *ngIf="menuafterresponse"
              >
                <img id="retry" />
                <span class="tooltiptext">Retry</span>
              </button>
              <button
                id="adv-tech"
                class="download-img tooltipss butn"
                (click)="copyText()"
                *ngIf="menuafterresponse"
              >
                <img
                  src="../../assets/images/About us-assets/copy-frame.svg"
                  alt=""
                />
                <span class="tooltiptext">Copy</span>
                <span
                  class="tooltiptext"
                  id="copried_txt"
                  *ngIf="!showParagraph && copiedtext"
                  >Copied</span
                >
              </button>
              <button
                class="mr-1 unquieBtn"
                (click)="downloadText()"
                *ngIf="menuafterresponse"
              >
                <img
                  src="../assets/images/plagiarism checker1/downPlag.svg"
                  alt="download-img"
                  style="margin-right: 5px"
                  class="unquieBtnImg"
                />
                Download
              </button>
              <button
                class="btn btn-dark btn-summarize"
                (click)="handleButtonClick()"
              >
              
              Paraphrase Text
              </button>
            </div>
          </div>

          <div class="mbl-screen">
            <div
              class="d-flex"
              style="
                justify-content: center;
                align-items: center;
                justify-items: center;
              "
            >
              <button
                id="adv-tech"
                class="download-img tooltipss butn"
                aria-label="Try Again"
                (click)="handleButtonClick()"
                *ngIf="menuafterresponse"
              >
                <img id="retry" />
                <span class="tooltiptext">Retry</span>
              </button>
              <button
                id="adv-tech"
                class="download-img tooltipss butn"
                (click)="copyText()"
                *ngIf="menuafterresponse"
              >
                <img
                  src="../../assets/images/About us-assets/copy-frame.svg"
                  alt=""
                />
                <span class="tooltiptext">Copy</span>
                <span
                  class="tooltiptext"
                  id="copried_txt"
                  *ngIf="!showParagraph && copiedtext"
                  >Copied</span
                >
              </button>
              <button
                class="mr-1 unquieBtn"
                (click)="downloadText()"
                *ngIf="menuafterresponse"
              >
                <img
                  src="../assets/images/plagiarism checker1/downPlag.svg"
                  alt="download-img"
                  style="margin-right: 5px"
                  class="unquieBtnImg"
                />
                <span> Download</span>
                
              </button>
            </div>
            <button
              class="btn btn-dark btn-summarize mt-3"
              (click)="parapharsing()"
            >
             
            Paraphrase Text
            </button>
          </div>

          <!-- code for validation  -->
          <div
            *ngIf="error"
            class="backdrop"
            style="
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-color: rgba(0, 0, 0, 0.5);
              z-index: 1000;
            "
          ></div>

          <div
            *ngIf="error"
            class="content-div"
            style="
              position: fixed;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 468px;
              height: 360px;
              background-color: white;
              z-index: 1010;
              border-radius: 4px;
              border: 1px solid white;
            "
          >
            <div class="text-center" style="margin-top: 9%">
              <app-icons-free-tools name="errorIcon" />

              <div style="width: 440px; height: 64px; margin-left: 16px">
                <p
                  class="error mt-4 content-div-p"
                  style="
                    font-size: 20px;
                    font-weight: 500;
                    line-height: 33.89px;
                  "
                >
                  {{ errorAlerts }}
                </p>
              </div>

              <button class="mt-4 butn-alert" (click)="closeErrorDiv()">
                Ok
              </button>
            </div>
          </div>

          <div
            *ngIf="success"
            class="backdrop"
            style="
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-color: rgba(0, 0, 0, 0.5);
              z-index: 1000;
            "
          ></div>

          <div
            *ngIf="success"
            class="content-div"
            style="
              position: fixed;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 468px;
              height: 360px;
              background-color: white;
              z-index: 1010;
              border-radius: 4px;
              border: 1px solid white;
            "
          >
            <div class="text-center" style="margin-top: 9%">
              <app-icons-free-tools name="successIcon" />
              <p
                *ngIf="success"
                class="error mt-4 content-div-p"
                style="font-size: 24px; font-weight: 500; line-height: 33.89px"
              >
                {{ successAlert }}
              </p>
            </div>
          </div>
          <!-- code for validation  -->
        </div>
      </div>
    </div>
  </div>
</div>
<!--  -->
<!-- Section 2 -->
<div
  class="container justify-content-center"
  id="paraph-how"
  style="margin-top: 20px; justify-content: center; text-align: center"
>
  <h2
    style="font-weight: 700; text-align: center; font-size: 30px"
    class="mbl-view"
  >
    How to Paraphrase a Content Online?
  </h2>
  <p class="fnt-18-400" style="text-align: center">
    Online paraphrasing becomes a no-uphill task for everyone. Simply follow the
    set of instructions <br />
    shared below and rephrased any text like a pro.
  </p>
  <div class="row justify-content-center">
    <div class="tabs">
      <div class="row">
        <img
          src="../../assets/images/paraphrasing tool/paraphase/upload.svg"
          id="home-tabs-img"
          alt="home-tabs-img"
        />
      </div>

      <div class="row" style="float: left; text-align: left; margin-top: 20px">
        <p class="fnt-w500-16">
          Upload the text file or paste the text you want to paraphrase directly
          in the given field.
        </p>
      </div>
    </div>
    <div class="tabs">
      <div class="row">
        <img
          src="../../assets/images/paraphrasing tool/paraphase/choose.svg"
          id="home-tabs-img"
          alt="home-tabs-img1"
        />
      </div>
      <div class="row" style="float: left; text-align: left; margin-top: 20px">
        <p class="fnt-w500-16">
          Choose the Paraphrasing Mode from the mentioned options.
        </p>
      </div>
    </div>
    <div class="tabs">
      <div class="row">
        <img
          src="../../assets/images/paraphrasing tool/paraphase/Tap on the Paraphrase.svg"
          id="home-tabs-img"
          alt="home-tabs-img2"
        />
      </div>
      <div class="row" style="float: left; text-align: left; margin-top: 20px">
        <p class="fnt-w500-16">
          Tap on the Paraphrase Text button to start the process.
        </p>
      </div>
    </div>
    <div class="tabs">
      <div class="row">
        <img
          src="../../assets/images/paraphrasing tool/paraphase/online paraphrasing.svg"
          id="home-tabs-img"
          alt="home-tabs-img3"
        />
      </div>
      <div class="row" style="float: left; text-align: left; margin-top: 20px">
        <p class="fnt-w500-16">
          This online paraphrasing tool will start working on your uploaded text
          and give you 100% unique and inspiring rephrasing results.
        </p>
      </div>
    </div>
  </div>
</div>

<div class="container mt-5">
  <app-premium />
</div>

<!-- AI-Generated Content Section -->
<div
  class="container justify-content-center"
  id="how-to-use-bg "
  style="margin-top: 60px"
>
  <div class="row mt-5" style="box-sizing: border-box" id="para-key-main">
    <div class="col-md-12">
      <h2
        style="
          text-align: center;
          font-size: 30px;
          font-weight: 700;
          line-height: 34px;
          text-align: center;
        "
        class="phone-view"
      >
        Key Features of Our Online Paraphrasing Tool
      </h2>
    </div>
    <div
      class="col-md-12"
      style="
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        line-height: 30px;
      "
    >
      <p>
        The web-based online rephrasing utility offers its users the simplest
        way to generate inspiring and fresh content. Some of the <br />
        other primary features of this online article paraphrasing tool are
        shared below.
      </p>
    </div>
    <div class="tabs_wrapper mt-5">
      <div class="col-lg-6 d-md-none d-block">
        <div class="">
          <select
            class="form-select mb-3"
            [(ngModel)]="selectedTab"
            (change)="selectTab(selectedTab)"
          >
            <option value="tab1">Al-Powered Technology</option>
            <option value="tab2">Fast & Free</option>
            <option value="tab3">Unique Text</option>
            <option value="tab4">Structured Content</option>
          </select>
        </div>
      </div>
      <div class="col-lg-6 d-md-block d-none">
        <div class="btns-divs">
          <button
            class="mb-3 mybtn p-2"
            [ngClass]="{ active: selectedTab === 'tab1' }"
            (click)="selectTab('tab1')"
            id="adv-tech"
          >
            <img
              id="al-power"
              class="section-3-plag-tabs-img me-3 ms-2"
              alt="plag-img"
            />
            <h3 class="section-3-plag-tabs-p" style="margin-top: 5px">
              Al-Powered technology
            </h3>
          </button>
          <button
            class="mb-3 mybtn p-2"
            [ngClass]="{ active: selectedTab === 'tab2' }"
            (click)="selectTab('tab2')"
            id="adv-tech"
          >
            <img
              id="free-use-plag"
              class="section-3-plag-tabs-img me-3 ms-2"
              alt="plag-img"
            />
            <h3 class="section-3-plag-tabs-p">fast & free</h3>
          </button>
          <button
            class="mb-3 mybtn p-2"
            [ngClass]="{ active: selectedTab === 'tab3' }"
            (click)="selectTab('tab3')"
            id="adv-tech"
          >
            <img
              id="unique-content"
              class="section-3-plag-tabs-img me-3 ms-2"
              alt="plag-img"
            />
            <h3 class="section-3-plag-tabs-p" style="margin-top: 0px">
              Unique Text
            </h3>
          </button>
          <button
            class="mb-3 mybtn p-2"
            [ngClass]="{ active: selectedTab === 'tab4' }"
            (click)="selectTab('tab4')"
            id="adv-tech"
          >
            <img
              id="structure-content"
              class="section-3-plag-tabs-img me-3 ms-2"
              alt="plag-img"
            />
            <h3 class="section-3-plag-tabs-p">Structured Content</h3>
          </button>
        </div>
      </div>
      <div class="col-lg-6">
        <div
          class="tab_container"
          style="background-color: #f7f7fa; border-radius: 8px"
        >
          <div *ngIf="selectedTab === 'tab1'" class="tab_content">
            <p id="contentss">
              The advanced paraphraser incorporates natural language processing
              algorithms and artificial intelligence technology that gives it
              the capability to understand the context of any text perfectly.
              Then, the backend algorithms recreate the entire text while
              keeping the actual meaning of the content.
            </p>
          </div>
          <div *ngIf="selectedTab === 'tab2'" class="tab_content">
            <p id="contentss">
              Conventional ways of paraphrasing an article require extensive
              time and effort. But our tool allows you to get rid of all
              traditional methods and paraphrase any content in no time. In
              addition, this AI paraphrasing tool doesn’t demand any premium
              membership from its users. Yes! You can generate countless
              articles with this web-based paraphraser without paying a single
              penny.
            </p>
          </div>
          <div *ngIf="selectedTab === 'tab3'" class="tab_content">
            <p id="contentss">
              Plagiarism is a serious crime that can cause serious trouble for
              an individual. You may face severe punishments or face
              embarrassment because of duplicated text. That’s why it is
              important to remove all instances of plagiarism from your written
              content before submitting it. Our paraphrasing tool enables you to
              eliminate any copied text from your content and make it impressive
              and eye-catching for the readers.
            </p>
          </div>
          <div *ngIf="selectedTab === 'tab4'" class="tab_content">
            <p id="contentss">
              Besides offering you an easy way to generate content, the facility
              also helps you to improve the structure of your text. Using this
              free tool, you can elevate the engagement of your text and bring
              more clarity to it.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- -->
  <div
    class="container"
    style="margin-top: 50px; box-sizing: border-box; text-align: left"
    id="para-key-phone"
  >
    <h2
      style="
        text-align: center;
        font-size: 30px;
        font-weight: 700;
        line-height: 37.8px;
        text-align: center;
      "
    >
      Key Features of Our Online Paraphrasing Tool
    </h2>
    <div
      class="col-md-12"
      style="
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        line-height: 30px;
      "
    >
      <p>
        The web-based online rephrasing utility offers its users the simplest
        way to generate inspiring and fresh content. Some of the <br />
        other primary features of this online article paraphrasing tool are
        shared below.
      </p>
    </div>
    <div
      class="v-pills-tab-list row"
      id="v-pills-tab-list"
      style="width: -webkit-fill-available"
    >
      <div class="" id="row_faqs">
        <div
          class="nav flex-column nav-pills"
          id="v-pills-tab"
          role="tablist"
          aria-orientation="vertical"
        >
          <a
            class="nav-link nav-pills"
            style="margin: 8px 0; padding: 10px 14px; background: #fff"
            class="card active"
            id="v-pills-first-tab"
            aria-controls="q122"
            aria-expanded="false"
            class="mb-0 collapsed"
            data-toggle="collapse"
            href="#q122"
          >
            <h5>
              <span
                class="btn active"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne_One"
                aria-expanded="true"
                aria-controls="collapseOne_One"
                class="card-header headingsize"
                >AI-Powered technology</span
              >
              <i class="fas fa-chevron-down float-right down"></i>
            </h5>
            <div
              aria-labelledby="q122"
              class="collapse"
              id="q122"
              role="tabpanel"
              data-parent="#v-pills-tab-list"
            >
              <div class="card-body">
                The advanced paraphraser incorporates natural language
                processing algorithms and artificial intelligence technology
                that gives it the capability to understand the context of any
                text perfectly. Then, the backend algorithms recreate the entire
                text while keeping the actual meaning of the content.
              </div>
            </div>
          </a>
          <hr style="margin-top: 0px; margin-bottom: 0px" />
          <a
            class="nav-link nav-pills"
            style="margin: 8px 0; padding: 10px 14px; background: #fff"
            class="card active"
            id="v-pills-2nd-tab"
            aria-controls="q12"
            aria-expanded="false"
            class="mb-0 collapsed"
            data-toggle="collapse"
            href="#q64"
          >
            <h5>
              <span
                class="btn active"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne_One"
                aria-expanded="true"
                aria-controls="collapseOne_One"
                class="card-header headingsize"
                >Fast & free</span
              >
              <i class="fas fa-chevron-down float-right down"></i>
            </h5>
            <div
              aria-labelledby="q122"
              class="collapse"
              id="q64"
              role="tabpanel"
              data-parent="#v-pills-tab-list"
            >
              <div class="card-body">
                Conventional ways of paraphrasing an article require extensive
                time and effort. But our tool allows you to get rid of all
                traditional methods and paraphrase any content in no time. In
                addition, this AI paraphrasing tool doesn’t demand any premium
                membership from its users. Yes! You can generate countless
                articles with this web-based paraphraser without paying a single
                penny.
              </div>
            </div>
          </a>
          <hr style="margin-top: 0px; margin-bottom: 0px" />
          <a
            class="nav-link nav-pills"
            style="margin: 8px 0; padding: 10px 14px; background: #fff"
            class="card active"
            id="v-pills-2nd-tab"
            aria-controls="q12"
            aria-expanded="false"
            class="mb-0 collapsed"
            data-toggle="collapse"
            href="#q74"
          >
            <h5>
              <span
                class="btn active"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne_One"
                aria-expanded="true"
                aria-controls="collapseOne_One"
                class="card-header headingsize"
                >Unique Text</span
              >
              <i class="fas fa-chevron-down float-right down"></i>
            </h5>
            <div
              aria-labelledby="q12"
              class="collapse"
              id="q74"
              role="tabpanel"
              data-parent="#v-pills-tab-list"
            >
              <div class="card-body">
                Plagiarism is a serious crime that can cause serious trouble for
                an individual. You may face severe punishments or face
                embarrassment because of duplicated text. That’s why it is
                important to remove all instances of plagiarism from your
                written content before submitting it. Our paraphrasing tool
                enables you to eliminate any copied text from your content and
                make it impressive and eye-catching for the readers.
              </div>
            </div>
          </a>
          <hr style="margin-top: 0px; margin-bottom: 0px" />
          <a
            class="nav-link nav-pills"
            style="margin: 8px 0; padding: 10px 14px; background: #fff"
            class="card active"
            id="v-pills-2nd-tab"
            aria-controls="q12"
            aria-expanded="false"
            class="mb-0 collapsed"
            data-toggle="collapse"
            href="#q81"
          >
            <h5>
              <span
                class="btn active"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne_One"
                aria-expanded="true"
                aria-controls="collapseOne_One"
                class="card-header headingsize"
                >Structured Content</span
              >

              <i class="fas fa-chevron-down float-right"></i>
            </h5>
            <div
              aria-labelledby="q12"
              class="collapse"
              id="q81"
              role="tabpanel"
              data-parent="#v-pills-tab-list"
            >
              <div class="card-body">
                Besides offering you an easy way to generate content, the
                facility also helps you to improve the structure of your text.
                Using this free tool, you can elevate the engagement of your
                text and bring more clarity to it.
              </div>
            </div>
          </a>
          <hr style="margin-top: 0px; margin-bottom: 0px" />
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid my-5" style="background: #ecf6f5">
  <div class="container">
    <div
      class="row justify-content-center"
      style="display: flex; align-items: center; padding: 30px 0px"
    >
      <div class="col-md-7 left-section">
        <h2 class="freeGrammarFont" id="align-center">
          Working on Our State of the Art Paraphrasing Tool
        </h2>
        <p class="freeGrammarFont-p" id="align-center">
          Our top-notch paraphrasing tool uses machine learning and AI to
          provide you with the best quality rewriting results. The output you
          get from this paraphraser will be flawless and completely
          human-looking. The backend technology of this web-based tool allows
          you to generate multiple versions of the same article in no time.
          Moreover, you can enhance the readability of a text and make it easily
          graspable for the readers with the aid of our online tool. The
          advanced rephrasing tool helps students learn grammar rules and
          enhance their vocabulary. This free paraphrasing tool is certainly a
          true helping hand for writers, students, social media users, and
          authors.
        </p>
      </div>
      <div class="col-md-5 right-section">
        <img
          class="how-to-img"
          src="../../assets/images/paraphrasing tool/paraphase/Working on Our State of the Art Paraphrasing Tool.svg "
          alt="text-ig"
        />
      </div>
    </div>
  </div>
</div>
<!-- benefits Most Section-->
<div
  class="container justify-content-center"
  id="how-to-use-bg "
  style="margin-top: 100px"
>
  <div class="row mt-5" style="box-sizing: border-box">
    <div class="col-md-12">
      <h2
        style="
          text-align: center;
          font-size: 30px;
          font-weight: 700;
          line-height: 34px;
          text-align: center;
        "
        class="scren-320"
      >
        Major Beneficiaries of This Paraphrase Text Online Tool
      </h2>
    </div>
    <div
      class="col-md-12"
      style="
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        line-height: 30px;
      "
    >
      <p>
        The online paraphrasing tool offered on this platform is immensely
        beneficial for people from almost every field and sector of <br />
        life. The biggest beneficiaries of this AI paraphraser are mentioned
        below.
      </p>
    </div>
  </div>
</div>
<div class="container text-center justify-content-center">
  <div class="row">
    <div class="col-lg-6">
      <img
        src="../../assets/images/paraphrasing tool/paraphase/Students.svg"
        class="article-8-img"
        alt="summarize"
      />
    </div>
    <div class="col-lg-6">
      <h2 class="fnt-w600-30 article-8-h2 mt-5">Students</h2>
      <p class="fnt-18-400 mt-4 article-8-p">
        If you are a student and searching for a useful tool that helps you
        craft the best-quality writing assignments, then you are at the right
        place. This online facility provides you with the perfect way to
        generate 100% original and error-free academic content within no time.
        The articles or essays you generate with this tool will be human-looking
        and inspiring for readers.
      </p>
    </div>
  </div>
</div>
<div class="container text-center justify-content-center">
  <div class="row" id="artical-9">
    <div class="col-lg-6 left-section">
      <h2 class="fnt-w600-30 article-8-h2 mt-5">Researchers</h2>
      <p class="fnt-18-400 mt-4 article-8-p">
        Our rephrasing tool offers great support to researchers in displaying
        their research in a perfect way and avoiding plagiarism. The online
        facility removes plagiarism from your entered text and adds creativity
        and engaging words to your work.
      </p>
    </div>
    <div class="col-lg-6 right-section">
      <img
        src="../../assets/images/paraphrasing tool/paraphase/Researchers.svg"
        class="article-8-img"
        alt="summarize1"
      />
    </div>
  </div>
</div>
<div class="container text-center justify-content-center">
  <div class="row">
    <div class="col-lg-6">
      <img
        src="../../assets/images/paraphrasing tool/paraphase/Script Writers.svg"
        class="article-8-img"
        alt="summarize3"
      />
    </div>
    <div class="col-lg-6">
      <h2 class="fnt-w600-30 article-8-h2 mt-5">Script Writers</h2>
      <p class="fnt-18-400 mt-4 article-8-p">
        Scriptwriters are expected to craft words that can captivate the
        audience instantly. With our free tool, they can elevate their
        creativity and transform their ideas into the most fascinating
        scenarios. The generated text will surely have the ability to engage
        their targeted audience.
      </p>
    </div>
  </div>
</div>
<div class="container text-center justify-content-center">
  <div class="row" id="artical-9">
    <div class="col-lg-6 left-section">
      <h2 class="fnt-w600-30 article-8-h2 mt-5">Bloggers</h2>
      <p class="fnt-18-400 mt-4 article-8-p">
        Bloggers and website owners require unique and best-quality content that
        can attract readers and boost traffic on their websites. Our free
        utility allows them to produce the best-performing blog content swiftly.
        Using this tool, you can fulfill the demand for appealing content for
        your websites without the assistance of professional writers.
      </p>
    </div>
    <div class="col-lg-6 right-section">
      <img
        src="../../assets/images/paraphrasing tool/paraphase/Bloggers.svg"
        class="article-8-img"
        alt="summarize1"
      />
    </div>
  </div>
</div>
<!-- frequently asked questions  section -->
<div class="container mt-5 qustion" id="home-faqs">
  <div
    class="row row justify-content-center"
    id="row_faqs"
    style="margin-bottom: 20px"
  >
    <div class="faqs text-center">
      <h1 class="text-center">Frequently asked questions</h1>
      <p style="text-align: center" class="text mb-5 text">
        Learn more about platform by user questions
      </p>
    </div>
    <div class="v-pills-tab-list row" id="v-pills-tab-list">
      <div id="row_faqs">
        <div
          class="container container-grid"
          style="width: min(100% - 40px, 768px)"
        >
          <div
            class="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <a
              class="nav-link nav-pills"
              style="
                border: 1px solid #eaeaea;

                padding: 10px 14px;
                background-color: #f3f8fc;
                border-radius: 10px;
              "
              [ngClass]="{ active: activeTab === 'q5' }"
              (click)="toggleTab('q5')"
              id="v-pills-first-tab"
              aria-controls="q5"
              aria-expanded="false"
              class="mb-0 collapsed"
            >
              <div class="nav-linkFAQ">
                <h3
                  class="card-header ms-3"
                  [class.closed]="activeTab !== 'q5'"
                >
                  How Can I Paraphrase Articles?
                </h3>
                <app-icons-free-tools
                  name="plusIcon"
                  *ngIf="activeTab !== 'q5'"
                />
                <app-icons-free-tools
                  name="minusIcon"
                  *ngIf="activeTab === 'q5'"
                />
              </div>

              <div
                aria-labelledby="q5"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q5' }"
                id="q5"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body carbody ms-3 me-3">
                  Simply paste the text you want to paraphrase and press the
                  given button. Our paraphrasing tool will examine your text and
                  provide you with a better copy of it in no time.
                </div>
              </div>
            </a>
          </div>

          <div
            class="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <a
              class="nav-link nav-pills"
              style="
                border: 1px solid #eaeaea;

                padding: 10px 14px;
                background-color: #f3f8fc;
                border-radius: 10px;
              "
              [ngClass]="{ active: activeTab === 'q15' }"
              (click)="toggleTab('q15')"
              id="v-pills-2nd-tab"
              aria-controls="q15"
              aria-expanded="false"
              class="mb-0 collapsed"
            >
              <div class="nav-linkFAQ">
                <h3
                  class="card-header ms-3"
                  [class.closed]="activeTab !== 'q15'"
                >
                  Do I Need to Sign Up to use this Online Paraphraser?
                </h3>
                <app-icons-free-tools
                  name="plusIcon"
                  *ngIf="activeTab !== 'q15'"
                />
                <app-icons-free-tools
                  name="minusIcon"
                  *ngIf="activeTab === 'q15'"
                />
              </div>

              <div
                aria-labelledby="q15"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q15' }"
                id="q15"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body carbody ms-3 me-3">
                  Not at all! This online paraphrasing utility doesn’t demand
                  any personal information from its users. They also don’t
                  require the installation of any application for paraphrasing
                  articles with this tool.
                </div>
              </div>
            </a>
          </div>
          <div
            class="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <a
              class="nav-link nav-pills"
              style="
                border: 1px solid #eaeaea;

                padding: 10px 14px;
                background-color: #f3f8fc;
                border-radius: 10px;
              "
              [ngClass]="{ active: activeTab === 'q6' }"
              (click)="toggleTab('q6')"
              id="v-pills-4th-tab"
              aria-controls="q6"
              aria-expanded="false"
              class="mb-0 collapsed"
            >
              <div class="nav-linkFAQ">
                <h3
                  class="card-header ms-3"
                  [class.closed]="activeTab !== 'q6'"
                >
                  Is This Online Paraphrasing Tool Free for Everyone?
                </h3>
                <app-icons-free-tools
                  name="plusIcon"
                  *ngIf="activeTab !== 'q6'"
                />
                <app-icons-free-tools
                  name="minusIcon"
                  *ngIf="activeTab === 'q6'"
                />
              </div>

              <div
                aria-labelledby="q6"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q6' }"
                id="q6"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body carbody ms-3 me-3">
                  Yes! Our web-based paraphrasing tool is completely free to
                  use. You can access it anytime and paraphrase unlimited
                  articles, essays, or blog posts without spending a single
                  penny.
                </div>
              </div>
            </a>
          </div>

          <div
            class="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <a
              class="nav-link nav-pills"
              style="
                border: 1px solid #eaeaea;

                padding: 10px 14px;
                background-color: #f3f8fc;
                border-radius: 10px;
              "
              [ngClass]="{ active: activeTab === 'q7' }"
              (click)="toggleTab('q7')"
              id="v-pills-5th-tab"
              aria-controls="q7"
              aria-expanded="false"
              class="mb-0 collapsed"
            >
              <div class="nav-linkFAQ">
                <h3
                  class="card-header ms-3"
                  [class.closed]="activeTab !== 'q7'"
                >
                  Does This Paraphrasing Tool Support Multiple Languages?
                </h3>
                <app-icons-free-tools
                  name="plusIcon"
                  *ngIf="activeTab !== 'q7'"
                />
                <app-icons-free-tools
                  name="minusIcon"
                  *ngIf="activeTab === 'q7'"
                />
              </div>

              <div
                aria-labelledby="q7"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q7' }"
                id="q7"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body carbody ms-3 me-3">
                  Yes! Our tool allows you to paraphrase text in different
                  languages. Besides English, this tool supports Spanish,
                  French, Italian, Hindi, Greek, Arabic, Chinese, Portuguese,
                  and many other languages.
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end section 7  -->
<app-feedback></app-feedback>
<a
  (click)="scrollToTop()"
  *ngIf="shouldShowButton"
  id="scroll-to-top"
  data-tooltip="Go to top"
>
  <app-icons-free-tools name="goToTopIcon" />
</a>

<app-premium-modal-startup></app-premium-modal-startup>
<app-footer></app-footer>
